import React from "react";

const Logo: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div
    className={`w-14 h-14 rounded-full bg-red-100 flex items-center justify-center ${className}`}
  >
    <svg
      className="w-8 h-8 text-red-500"
      fill="none"
      viewBox="0 0 32 32"
      stroke="currentColor"
    >
      <rect x="4" y="4" width="24" height="24" rx="6" fill="#ef4444" />
      <text
        x="16"
        y="22"
        textAnchor="middle"
        fontSize="14"
        fill="white"
        fontWeight="bold"
      >
        F
      </text>
    </svg>
  </div>
);

export default Logo;
